module.exports = __webpack_public_path__ + "static/eating-602cde5426424bdc7c048ff5e3c2a46e.jpg";